import { apiService, API_BASE_URL } from './api';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const avatarApi = {
  url(version?: number | string) {
    const v = version ? `?v=${encodeURIComponent(String(version))}` : '';
    return `${API_BASE_URL}${API_ENDPOINTS.USERS.AVATAR}${v}`;
  },
  async upload(file: File): Promise<{ version?: number; contentType?: string; size?: number }> {
    return apiService.uploadFile(API_ENDPOINTS.USERS.AVATAR, file);
  },
  async remove(): Promise<void> {
    return apiService.delete(API_ENDPOINTS.USERS.AVATAR);
  },
};
